
import FormatterService from "@/service/FormatterService";
import { repeatUnitValues, daysOfWeekValues, endsTypeValues } from '@/constants/finAgent';

export default {
    name: "CustomAutoAskQuestionFrequency",

    props: {
        value: {
            type: Object,
            required: true,
        },
        errorFrequencyInterval: {
            type: String,
            default: '',
        },
        errorFrequencyEndOccurrences: {
            type: String,
            default: '',
        },
    },

    emits: ['update:value', 'validation'],

    data() {
        const today = new Date();
        today.setDate(today.getDate() + 1); // today + 1 day

        return {
            dateMenu: false,
            minDate: today.toISOString().slice(0, 10), // Format YYYY-MM-DD
        };
    },

    computed: {
        endDateFormatted() {            
            return this.value.frequencyEndDate ? this.formatter.formatDDMMMYYY(new Date(this.value.frequencyEndDate)) : "";
        },
        endModeProxy: {
            get() {
                return this.value.frequencyEndMode;
            },
            set(val) {
                this.updateField('frequencyEndMode', val);
            }
        },
        endDateProxy: {
            get() {
                return this.value.frequencyEndDate;
            },
            set(val) {
                this.updateField('frequencyEndDate', val);
            }
        },
    },
    watch: {
        value: {
            handler(val) {
                this.validateFields(val);
            },
            deep: true,
            immediate: true,
        },
    },

    created() {
        this.formatter = new FormatterService()
        this.endsTypeValues = endsTypeValues;
        this.repeatUnitValues = repeatUnitValues;
        this.repeatUnitOptions = [
            {
                value: repeatUnitValues.day,
                text: this.$t("components.customAutoAskQuestionFrequency.day"),
            },
            {
                value: repeatUnitValues.week,
                text: this.$t("components.customAutoAskQuestionFrequency.week"),
            },
        ];
        this.daysOfWeek= [
            {
                value: daysOfWeekValues.sun,
                label: this.$t("components.customAutoAskQuestionFrequency.sun"),
            },
            {
                value: daysOfWeekValues.mon,
                label: this.$t("components.customAutoAskQuestionFrequency.mon"),
            },
            {
                value: daysOfWeekValues.tue,
                label: this.$t("components.customAutoAskQuestionFrequency.tue"),
            },
            {
                value: daysOfWeekValues.wed,
                label: this.$t("components.customAutoAskQuestionFrequency.wed"),
            },
            {
                value: daysOfWeekValues.thu,
                label: this.$t("components.customAutoAskQuestionFrequency.thu"),
            },
            {
                value: daysOfWeekValues.fri,
                label: this.$t("components.customAutoAskQuestionFrequency.fri"),
            },
            {
                value: daysOfWeekValues.sat,
                label: this.$t("components.customAutoAskQuestionFrequency.sat"),
            },
        ];
    },

    methods: {
        clickFrequencyWeekday(day) {
            if (day === this.value.frequencyWeekday) {
                return;
            }
            this.updateField('frequencyWeekday', day);
        },

        // Prevent negative numbers in input fi elds
        preventMinus(e) {
            if (e.key === '-' || e.key === 'e') {
                e.preventDefault();
            }
        },

        updateField(field, val) {
            const updated = { ...this.value };
            updated[field] = val;
            this.$emit('update:value', updated);
            this.validateFields(updated);
        },

        validateFields() {
            let errorFrequencyInterval = '';
            let errorFrequencyEndOccurrences = '';

            if (!this.value.frequencyInterval || this.value.frequencyInterval < 1) {
                errorFrequencyInterval = this.$t('components.customAutoAskQuestionFrequency.repeatEveryRequired');
            }

            if (
                this.value.frequencyEndMode === endsTypeValues.after &&
                (!this.value.frequencyEndOccurrences || this.value.frequencyEndOccurrences < 1)
            ) {
                errorFrequencyEndOccurrences = this.$t('components.customAutoAskQuestionFrequency.endsAfterRequired');
            }

            this.$emit('validation', { errorFrequencyInterval, errorFrequencyEndOccurrences });
        },
    },
};
